import React from 'react';
import { Stack, Text, Divider } from '@moda/om';
import { AuthAction } from '../../lib/authenticate';
import { SocialAuthButtons } from './SocialAuthButtons';
import { SocialAuthTheme } from './SocialAuthButton';

type CheckoutSocialAuthButtonsProps = {
  theme?: SocialAuthTheme;
};

export const CheckoutSocialAuthButtons: React.FC<CheckoutSocialAuthButtonsProps> = ({
  theme = 'color'
}) => (
  <Stack space={4}>
    <Divider text="OR" treatment="body1" family="sans" />
    <Stack space={3} alignItems="center">
      <Text>Skip the forms and use your saved information.</Text>
      <SocialAuthButtons action={AuthAction.SignIn} theme={theme} />
    </Stack>
  </Stack>
);
